<template>
    <div class="text_editor" :class="wrapclass" >
        <label v-if="label" class="editor-label">{{ label }} <em v-if="checkFieldIsRequired({
                'key': tplkey, 'section': tplsection, 'fieldsArray': fieldsArray,
                'required': required
            })">*</em></label>
        <input  type="file" @change="imageHandler" id="file" accept="image/*" hidden>
        <quill-editor v-if="isAllOptions"  @keydown.native.enter="handleEnterKey" :key="fieldName + cid" :name="fieldName + cid" :ref="fieldName"
            @input="updateData()" :data-vv-as="vvas ? vvas : placeHolder" :placeholder="placeHolder" v-validate="checkFieldIsRequired({
                'key': tplkey, 'section': tplsection, 'fieldsArray': fieldsArray,
                'required': required
            }) ? 'required|' + datatype : datatype" v-model="value" :options="editorOptions"
            @change="handleEditorChange" :disabled="disabled" @contextmenu.prevent="handleRightClick"></quill-editor>
            <template v-if="formscope">
            <span v-if="errors.has(formscope + '.' + fieldName + cid)" class="error_text">{{
                errors.first(formscope + '.' + fieldName + cid) }}</span>
            <span v-else-if="checkValidation && required" class="error_text">*{{ vvas ? vvas : placeHolder }} is
                required</span>
        </template>
        <template v-else>
            <span v-if="errors.has(fieldName + cid) && required" class="error_text">{{ errors.first(fieldName + cid)
            }}</span>
            <span v-else-if="checkValidation && required" class="error_text">*{{ vvas ? vvas : placeHolder }} is
                required</span>
        </template>

        <div v-if="showSuggestions" class="suggestions-menu" :ref="fieldName + 'suggestionsMenu'">
            <div v-for="suggestion in suggestions" :key="suggestion">
                <button @click="applySuggestion(suggestion)">{{ suggestion }}</button>
            </div>
        </div>
        <modal
        
            style="z-index:999999"
            z-index="9999"
            :name="fieldName+'editorCropImageModal'"
            classes="v-modal-sec"
            :min-width="200"
            :min-height="200"
            :scrollable="true"
            :reset="true"
            width="750px"
            height="auto"
          >
          <div class="v-modal profile_details_modal error-modal-space" >
            <div class="popup-header fromDetailsPage">
              <h2 class="popup-title">
                <template >Crop Image</template>
               
              </h2>
              <span @click="$modal.hide(fieldName+'editorCropImageModal');">
                <em class="material-icons">close</em>
              </span>
            </div>
            </div>
            <div  class="row">
                <cropper v-if="sourceImg!=''"  ref="editorCropper" class="cropper"  :src="sourceImg" :stencil-props="stencilProps"  @change="change"></cropper>
                <div class="popup-footer relative">
                <span class="loader" v-if="uploading"><img src="@/assets/images/main/loader.gif"></span>
                  <vs-button color="dark" class="cancel mb-0" type="filled" @click="previewCanvas=''; $modal.hide(fieldName+'editorCropImageModal')"  style="margin-bottom: 0 !important;">Cancel</vs-button>
                  <vs-button color="success" :disabled="uploading"  class="save" type="filled" style="margin-left: 10px !important;margin-bottom: 0 !important;" @click="uploadFinalImageToS3()">
                   <!---- Upload-->Crop</vs-button>
                </div>

            </div>
        
        </modal>
    </div>
    
</template>
<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.core.css';
import Quill from 'quill';
import axios from '@/axios.js';
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

const highlightBackgroundColor = '#fffb8e'; // Yellow background color
// Configure Quill to use <div> instead of <p>
let Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);

export default {
    inject: ["parentValidator"],
    props: {
        customValidNotRequire: {
            type: Boolean,
            dafault: false
        },
        display: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        fieldsArray: Array,
        vvas: {
            type: String,
            default: ""
        },
        wrapclass: {
            type: String,
            default: ""
        },
        datatype: {
            type: String,
            default: ""
        },
        cid: {
            type: String,
            default: null,
        },
        formscope: {
            type: String,
            default: null
        },
        value: null,
        label: {
            type: String,
            default: null,
        },
        fieldName: {
            type: String,
            default: 'editor_' + Date.now(),
        },
        tplsection: {
            type: String,
            default: null,
        },
        tplkey: {
            type: String,
            default: null,
        },
        placeHolder: {
            type: String,
            default: null,
        },
        cid: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        editorRequiredOptions: {
            default: null,
        },
        isAllOptionsRequired: {
            type: Boolean,
            default: false,
        },
        toolbarRequired: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        quillEditor,
    },
    created() {
        this.$validator = this.parentValidator;
    },
    methods: {
        imageHandler (e) {
                       let self = this;
                        var reader = new FileReader();
                        reader.readAsDataURL(e.target.files[0]);
                        reader.onload =  ()=> {
                            self.sourceImg = reader.result;
                            self.sourceImgTemp = reader.result;
                       self.$modal.show(this.fieldName+'editorCropImageModal')
                        };
                        reader.onerror =  (error)=> {
                            self.$modal.hide(this.fieldName+'editorCropImageModal')
                        
                        };
    // this.selectedFile = e.target.files[0];
    // var form = new FormData();
    // form.append('files', this.selectedFile);
    // form.append('secureType', 'public');
    // this.$store.dispatch('uploadS3File', form)
    // .then(response => {
    //   const urlGenerated = response.data.result[0];
    //   // Insert the image at the current cursor position
    //   this.$refs[this.fieldName].quill.focus();
    //   const range = this.$refs[this.fieldName].quill.getSelection();
    //   if(urlGenerated){
    //   this.$refs[this.fieldName].quill.insertEmbed(range.index, 'image', urlGenerated);
    //   }
    // })
    // .catch(error => {
    //   console.error('Error uploading image to S3:', error);
    // });
},
async uploadFinalImageToS3(){
    let previewCanvas  = this.previewCanvas
    const base64Response = await fetch(`${previewCanvas}`);
    base64Response.blob().then((file)=>{
   let self =this;
      let formData = new FormData();
         formData.append("files", file);
        formData.append("secureType", "public");
        this.$store.dispatch("uploadS3File", formData)
        .then(response => {
      const urlGenerated = response.data.result[0];
      // Insert the image at the current cursor position
      this.$refs[this.fieldName].quill.focus();
      const range = this.$refs[this.fieldName].quill.getSelection();
      if(urlGenerated){
      this.$refs[this.fieldName].quill.insertEmbed(range.index, 'image', urlGenerated);
      }
      this.$modal.hide(this.fieldName+'editorCropImageModal')
    })
    .catch(error => {
      console.error('Error uploading image to S3:', error);
      this.showToster({message:error,isError:true });
    });
    })
},
saveCropedImage(){
              this.previewCanvas ='';
              let cropedImage = this.$refs.editorCropper.getCanvas().toDataURL()
               this.previewCanvas =cropedImage
            },
            change(event){
              this.saveCropedImage();
            },
        handleEnterKey(event) {

        },
        updateData() {
            if(this.value=='<div><br></div>'){
                this.value=''
            }
            this.$emit('input', this.value);
        },
        handleEditorChange({ quill, html, text }) {
            if (this.cancelTokenSource) {
                this.cancelTokenSource.abort()
            }
            if (text && text.length > 1) {
                if (this.typingTimeout) {
                    clearTimeout(this.typingTimeout);
                }
                this.typingTimeout = setTimeout(() => {
                    this.customSpellChecker(text, quill)
                }, 1000); // Adjust the delay as needed
            }
        },
        customSpellChecker(text, quill) {
            let postData = { 'message': text }
            this.cancelTokenSource = new AbortController();
            const signal = this.cancelTokenSource.signal;
            this.$store.dispatch("customSpellCheck", { 'data': postData, cancelTokenSource: signal }).then(response => {
                console.log('misspelledWords:', response);
                this.misspelledWords = response;
                this.highlightMisspelledWords(quill, response);
            });
        },
        highlightMisspelledWords(quill, misspelledWords) {
            quill.formatText(0, quill.getLength(), 'spellcheck', false);
            misspelledWords.forEach(item => {
                const indexes = this.getAllIndexes(quill.getText(), item.word);
                indexes.forEach(index => {
                    //quill.formatText(index, item.word.length, 'spellcheck', true);
                    const lineIndex = quill.getLine(index);
                    quill.formatLine(lineIndex, 1, 'spellcheck', true);
                });
            });
        },
        getAllIndexes(text, word) {
            const indexes = [];
            let index = text.indexOf(word);
            while (index !== -1) {
                indexes.push(index);
                index = text.indexOf(word, index + 1);
            }
            return indexes;
        },
        // handleDoubleClick(event) {
        //     const quill = this.$refs[this.fieldName].quill;
        //     const selection = quill.getSelection();
        //     if (selection) {
        //         const selectedText = quill.getText(selection.index, selection.length);
        //         if (selectedText) {
        //             console.log('misspelledWords', this.misspelledWords)
        //             const matchedWord = this.misspelledWords.find(item => item.word === selectedText.trim());
        //             console.log('matchedWord', matchedWord)
        //             if (matchedWord && matchedWord.suggestions.length > 0) {
        //                 this.showSuggestionsForWord(quill, matchedWord);
        //             } else {
        //                 this.clearSuggestions(quill);
        //             }
        //         }
        //     }
        // },
        showSuggestionsForWord(quill, matchedWord) {
            this.showSuggestions = true;
            setTimeout(() => {
                const bounds = quill.getBounds(quill.getSelection());
                const menu = this.$el.querySelector('.suggestions-menu');
                if (menu) {
                    // Set menu position
                    menu.style.top = (bounds.bottom + 60) + 'px';
                    menu.style.left = bounds.left + 'px';
                    // Update suggestions and show the menu
                    this.suggestions = matchedWord.suggestions;
                }
            })
            document.addEventListener('click', this.handleDocumentClick);
        },
        clearSuggestions(quill) {
            this.showSuggestions = false;
        },
        applySuggestion(suggestion) {
            // Implement logic to apply the selected suggestion
            // For example, replace the selected word with the suggestion
            const quill = this.$refs[this.fieldName].quill;
            const selection = quill.getSelection();
            quill.deleteText(selection.index, selection.length);
            quill.insertText(selection.index, suggestion);

            // Clear the suggestions menu
            this.clearSuggestions();
        },

        handleRightClick(event) {
            const quill = this.$refs[this.fieldName].quill;
            const target = quill.container.querySelector('.ql-editor');
            const range = quill.getSelection();
            if (range && range.length === 0) {
                const selectedText = this.getWordUnderCursor(quill, range.index);
                if (selectedText) {
                 let cleanedText=''
                    if (selectedText.endsWith(".")) {
                        //cleanedText = selectedText.replace(/\.([^.]*)$/, '$1');
                        cleanedText = selectedText.replace(/\.{2,}$/, '').replace(/\.$/, '');
                    } else {
                        cleanedText = selectedText;
                    }
                    const wordStart = range.index - this.getWordStartOffset(quill, range.index);
                    quill.setSelection(wordStart, cleanedText.length, 'user');
                    const matchedWord = this.misspelledWords.find(item => item.word === cleanedText.trim());
                    if (matchedWord && matchedWord.suggestions.length > 0) {
                        event.preventDefault();
                        this.showSuggestionsForWord(quill, matchedWord);
                    } else {
                        this.clearSuggestions(quill);
                    }
                }
            }
            if(this.showSuggestions){
                event.preventDefault();  
            }
        },

        getWordUnderCursor(quill, index) {
            const textBeforeCursor = quill.getText(0, index);
            const textAfterCursor = quill.getText(index, quill.getLength() - index);
            const wordBeforeCursor = textBeforeCursor.match(/(\S+)$/);
            const wordAfterCursor = textAfterCursor.match(/^(\S+)/);
            const completeWord = (wordBeforeCursor ? wordBeforeCursor[1] : '') + (wordAfterCursor ? wordAfterCursor[1] : '');

            return completeWord.trim();
        },
        getWordStartOffset(quill, index) {
            // Calculate the offset to find the start position of the word
            let offset = 0;
            for (let i = index - 1; i >= 0; i--) {
                const char = quill.getText(i, 1);
                if (/\s/.test(char)) {
                    break; // Word boundary reached
                }
                offset++;
            }
            return offset;
        },
        handleDocumentClick(event) {
            const suggestionsMenu = this.$refs[this.fieldName + 'suggestionsMenu']; // Adjust this to the actual ref you use
            if (suggestionsMenu && !suggestionsMenu.contains(event.target)) {
                this.showSuggestions = false;
                document.removeEventListener('click', this.handleDocumentClick);
            }
        },
    },
    data: () => ({
        isCropModal:false,
        uploading:false,
        previewCanvas:'',
        stencilProps:{
                class: 'cropper-stencil',
                previewClass: 'cropper-stencil__preview',
                draggingClass: 'cropper-stencil--dragging',
                minCropBoxWidth: 10,
                minCropBoxHeight:10,
                handlersClasses: {
                  default: 'cropper-handler',
                  eastNorth: 'cropper-handler--east-north',
                  westNorth: 'cropper-handler--west-north',
                  eastSouth: 'cropper-handler--east-south',
                  westSouth: 'cropper-handler--west-south',
                },
              },
        isAllOptions:false,
        editorAllOptions:null,
        editorOptions: {modules: {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'highlight'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{
            'color': ['#ffffff', '#000000', '#e6e6e6', '#6699cc', '#ffa500', '#d9d9d9', '#ffd700', '#8080ff', '#28a428',
                '#990000', '#ff0000', '#ffa500', '#ffff00', '#80ff80', '#339966', '#6666ff', '#66c2ff', '#006bb3', '#800080'
            ]
        },
        {
            'background': ['#ffffff',
                '#ffff00', '#4dff4d', '#00ffff', '#ff00ff', '#0000ff', '#ff0000', '#000099', '#008B8B',
                '#013220', '#8B008B', '#8B0000', '#8B8000',
                '#808080', '#D3D3D3', '#000000', 'transparent']
        }], // Add color and background options

    ],
}},
        misspelledWords: [],
        showSuggestions: false,
        suggestions: [],
        typingTimeout: null,
        cancelTokenSource: null,
        showPreview:false,
                selectedFileName:'',
                sourceImg:'',
                sourceImgTemp:'',
                sourceFile:[],


    }),

    mounted() {
        setTimeout(() => {
            if (this.value) {
                const quill = this.$refs[this.fieldName].quill;
                if (quill) {
                    const selectedText = quill.getText()
                    this.customSpellChecker(selectedText, quill)
                }
            }
        })
        setTimeout(() => {
            this.isAllOptions=true
        },100)
        this.$nextTick(() => {
           // const quill = this.$refs[this.fieldName].quill;
            //   quill.container.addEventListener('contextmenu', this.handleRightClick);
            const quill = this.$refs[this.fieldName].quill;
            quill.container.addEventListener('contextmenu', this.handleRightClick);
            document.addEventListener('click', this.hideContextMenu);
        });
if(this.isAllOptionsRequired){
this.editorOptions={
    modules: {
          toolbar: {
            container: [
        ['bold', 'italic', 'underline', 'strike', 'highlight'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{
            'color': ['#ffffff', '#000000', '#e6e6e6', '#6699cc', '#ffa500', '#d9d9d9', '#ffd700', '#8080ff', '#28a428',
                '#990000', '#ff0000', '#ffa500', '#ffff00', '#80ff80', '#339966', '#6666ff', '#66c2ff', '#006bb3', '#800080'
            ]
        },
        {
            'background': ['#ffffff',
                '#ffff00', '#4dff4d', '#00ffff', '#ff00ff', '#0000ff', '#ff0000', '#000099', '#008B8B',
                '#013220', '#8B008B', '#8B0000', '#8B8000',
                '#808080', '#D3D3D3', '#000000', 'transparent']
        }],
              ["link", "image"],
              ['clean'],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'direction': 'rtl' }],
            //   [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          
            ],
            handlers: {
                  image: function() {
                    document.getElementById('file').click()
                  }
                }
          }
        }
}
}else if(!this.toolbarRequired){
    this.editorOptions = {
        modules: {
            toolbar: false
        }
    }
}



    },
    computed: {
        checkValidation() {
            let returnVal = false;
            if (this.value&&this.value.trim() === '<div><br></div>' && !this.customValidNotRequire) {
                returnVal = true;
            }
            // if (((this.value&&this.value.trim() === '<div><br></div>') || (this.value ==='')) && !this.customValidNotRequire) {
            //     returnVal = true;
            // }
            return returnVal
        }
    },
    beforeDestroy() {
        // const quill = this.$refs[this.fieldName].quill;
        // quill.container.removeEventListener('contextmenu', this.handleRightClick);
    },
};
</script>
